export default __webpack_public_path__ + "static/media/not_found.4861ae77.svg";